import React from 'react';
import { ChampionShip } from './tables/Championship';
export const ResultSportsTables = ((props) => <div>
      {props.sports.map((sport) => sport.championships.map((cfg) => <ChampionShip {...cfg} sportID={sport.id} key={`championship_${cfg.id}`} toLocale={props.toLocale} onClick={props.onClick} getInfo={props.getInfo} foldable={props.foldable}/>))}
   </div>);



// WEBPACK FOOTER //
// ./src/web-frontend-components/results/live/Tables.jsx